import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import {
  DropDownChonKetQuaThucHien,
  DropDownMulipleUse,
  DropDownChonKetQuaGiaiQuyet,
  DropDownChonKetLuanNoiDungKhieuNai
} from 'components/tt-forms';
import moment from 'moment';
import { GiaiQuyetDonThu } from 'api';
import { Link } from 'react-router';
import { ShowIf, ShowIfCheck } from 'components/utils';
import ConfirmDialog from './ConfirmDialog.jsx';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import { Input, InputNumber, Text, TextMessage, TextArea } from 'components/tt-forms/common';
import {BlockGiaiQuyetDonInfo} from 'modules/giai-quyet-don/subView';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class CanBoNhanYeuCauTheoDoiThucHien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      dataDetail: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      dataCoQuanTheoDoi: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],

      id: this.props.id,
      loaiDon: this.props.loaiDon,
      nextState: '',
      khoiTo : false,
      openDialog:false,
      soVuBiKhoiTo : 0,
      soDoiTuongBiKhoiTo : 0,
      hinhThucTheoDoi : '',
      coQuanTheoDoi : '',
      ketQuaThucHienTheoDoi : '',
      ketQuaThucHienKhac : '',
      tienPhaiThuNhaNuoc : 0,
      datPhaiThuNhaNuoc : 0,
      tienDaThuNhaNuoc : 0,
      datDaThuNhaNuoc : 0,
      tienPhaiTraCongDan : 0,
      datPhaiTraCongDan : 0,
      tienDaTraCongDan : 0,
      datDaTraCongDan : 0,
      ketQuaGiaiQuyetLan2: '',
      soLanGiaiQuyetLai: '',
      noiDungKetLuanGiaiQuyetLai: '',
      soVuGiaiQuyetKhieuNai: '',
      ketLuanNoiDungKhieuNai: '',
      ketQuaGiaiQuyetKhac: '',
      tienPhaiThuNhaNuocQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',
      soNguoiDuocTraLaiQuyenLoi: '',
      nguoiBanHanh: ''
    }
  }

  componentDidMount() {
    this.getCoQuanTheoDoiEnumn();
    if(this.props.dataNextStates && this.props.dataNextStates.length > 0) {
      this.checkOnlyState(this.props.dataNextStates);
    }
    this.getDetail(this.state.thongTinGiaiQuyetDonId);
    if (window.debug) {
      console.log('giai-quyet-don/subView/CanBoNhanYeuCauTheoDoiThucHien');
    }
  }

  getDetail(id) {
    if (typeof id != 'undefined') {
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({id:id}).then(res => {
        if (res.data) {
          this.setState({
            dataDetail: res.data,
            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',
          },() => {
            this.checkFileDinhKem();
            if(this.props.dataNextStates && this.props.dataNextStates.length > 0) {
              this.checkOnlyState(this.props.dataNextStates);
            }
          })
        }
      })
    }
  }

  checkFileDinhKem() {
    let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let dataView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = dataView.filter(state => {
      return this.compareDate(new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
    })
    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
      listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView
    } , () => {
      this.setState({
        showFile: true
      })
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  checkOnlyState(dataNextStates) {
    this.setState({
      nextState: dataNextStates[0].type
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      loaiDon: nextProps.loaiDon
    })
    if(this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
      this.checkOnlyState(nextProps.dataNextStates);
    }
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.props.handleChangeData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
      this.setState({
        noiDungKetLuanGiaiQuyetLai: ''
      })
    }
    this.props.handleChangeData();
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    });
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
    this.props.handleChangeData();
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    });
    this.handleKetThuc();
  }

  getParams() {
    let dataGQD = this.state.dataDetail;
    let params = getParams(dataGQD, this.state.id);

    if(params.giaoCoQuanDieuTra && this.state.khoiTo) {
      params.khoiTo = true;
      params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
      params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
    } else {
      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
    }

    params.theoDoiThucHien = true;
    params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
    if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
      params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
    } else {
      params.coQuanTheoDoi = null;
    }
    params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
    params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

    params.tienPhaiThuNhaNuoc = this.state.tienPhaiThuNhaNuoc ? Number(this.state.tienPhaiThuNhaNuoc) : 0;
    params.datPhaiThuNhaNuoc = this.state.datPhaiThuNhaNuoc ? Number(this.state.datPhaiThuNhaNuoc) : 0;
    params.tienPhaiTraCongDan = this.state.tienPhaiTraCongDan ? Number(this.state.tienPhaiTraCongDan) : 0;
    params.datPhaiTraCongDan = this.state.datPhaiTraCongDan ? Number(this.state.datPhaiTraCongDan) : 0;

    params.tienDaThuNhaNuoc = this.state.tienDaThuNhaNuoc ? Number(this.state.tienDaThuNhaNuoc) : 0;
    params.datDaThuNhaNuoc = this.state.datDaThuNhaNuoc ? Number(this.state.datDaThuNhaNuoc) : 0;
    params.tienDaTraCongDan = this.state.tienDaTraCongDan ? Number(this.state.tienDaTraCongDan) : 0;
    params.datDaTraCongDan = this.state.datDaTraCongDan ? Number(this.state.datDaTraCongDan) : 0;
    let isQDGQ = dataGQD.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET';
    params.soLanGiaiQuyetLai = (isQDGQ && this.props.loaiDon == 'DON_KHIEU_NAI') ? Number(this.state.soLanGiaiQuyetLai) : 0;
    params.ketQuaGiaiQuyetLan2 = Number(this.state.soLanGiaiQuyetLai) > 1 ?  this.state.ketQuaGiaiQuyetLan2 : null;
    params.noiDungKetLuanGiaiQuyetLai = (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I') ? this.state.noiDungKetLuanGiaiQuyetLai : '';
    params.soVuGiaiQuyetKhieuNai = isQDGQ ? Number(this.state.soVuGiaiQuyetKhieuNai) : 0;
    params.ketLuanNoiDungKhieuNai = isQDGQ ? this.state.ketLuanNoiDungKhieuNai : null;
    params.ketQuaGiaiQuyetKhac = isQDGQ ? this.state.ketQuaGiaiQuyetKhac : '';
    params.tienPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.tienPhaiThuNhaNuocQDGQ) : 0;
    params.datPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.datPhaiThuNhaNuocQDGQ) : 0;
    params.tienPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.tienPhaiTraCongDanQDGQ) : 0;
    params.datPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.datPhaiTraCongDanQDGQ) : 0;
    params.tongSoNguoiXuLyHanhChinh = isQDGQ ? Number(this.state.tongSoNguoiXuLyHanhChinh) : 0;
    params.soNguoiDaBiXuLyHanhChinh = isQDGQ ? Number(this.state.soNguoiDaBiXuLyHanhChinh) : 0;
    params.soNguoiDuocTraLaiQuyenLoi = isQDGQ ? Number(this.state.soNguoiDuocTraLaiQuyenLoi) : 0;
    params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    return params;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  handleKetThuc() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });
      let dataFileDinhKem = [...this.state.dataFileDinhKem];
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let _params = this.getParams();
      let params = {};
      if (this.props.tuGiaiQuyet == true) {
        params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId)
          }
        }
        if (this.state.dataDetail.huongThuLyGiaiQuyet == 'TU_TTXM') {
          params.actionType = 'QGD_TU_LUU_HO_SO_TDTH'
        } else {
          params.actionType = 'TRUONG_PHONG_TU_TDTH'
        }
      } else {
        let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
        });
        params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId),
          },
          nextState: {
            id: Number(selectedState[0].stateId),
          }
        }
      }
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
          });
        });
      });
    }
  }

  handleSave() {
    this.setState({
      btnLoading: true,
      btnSaveLoading: true
    });
    let dataFileDinhKem = [...this.state.dataFileDinhKem];
    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            loaiQuyTrinh: loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
          };
        }
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    let params = this.getParams();
    this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
      this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
        this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
          this.props.saveGiaiQuyetDon(params, 'gqdLuu');
        });
      });
    });
  }

  onFileChange(data, type) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    this.setState ({
      dataFileDinhKem: data
    });

    this.props.handleChangeData();

  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  render() {
    let DataDetail = this.state.dataDetail;
    let ketLuanNDKhieuNaiLabel = this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : (this.props.loaiDon == 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh");
    let labelQD = this.state.loaiDon == 'DON_TO_CAO' ? 'Quyết định giải quyết tố cáo' : (this.state.loaiDon == 'DON_KHIEU_NAI' ? 'Quyết định giải quyết khiếu nại' : 'Văn bản giải quyết kiến nghị, phản ánh');
    return (
      <section className="wrap-block">
        {
          DataDetail.donViGiaoThamTraXacMinhInfo != null &&
          <NhiemVuTTXM
            donViGiaoThamTraXacMinh={DataDetail.donViGiaoThamTraXacMinhInfo}
            ngayBatDauTTXM={DataDetail.ngayBatDauTTXM}
            yKienCuaDonViGiaoTTXM = {DataDetail.yKienCuaDonViGiaoTTXM}
            ngayHetHanTTXM={DataDetail.ngayHetHanTTXM}
            donInfo = {this.props.donInfo}
          />
        }
        {
          DataDetail.donViGiaoThamTraXacMinhInfo != null &&
            <div className="wrap-big-line pt5 pb15">
              <span className="big-border"></span>
            </div>
        }
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={this.state.dataDetail}/>

        <div className="row pl15 pr15">
          <div className="col-100 mt5 no-gutter">
            <h2 className="title-14 mb10">Thông tin giải quyết</h2>
          </div>

          <ShowIf condition={DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || DataDetail.ketQuaXLDGiaiQuyet == 'DANG_TDTH'}>
            <div className="col-100 no-gutter pt5 pb15">
              <span className="line-border"></span>
            </div>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">{labelQD}</h3>
            { /*Block edit thong tin quyet dinh giai quyet*/
              (DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.props.loaiDon == 'DON_KHIEU_NAI') &&
              <div className="row pl10 pr10">
                <ShowIf condition={this.state.soLanGiaiQuyetLai > 1}>
                  <DropDownChonKetQuaGiaiQuyet className='col-25' name="ketQuaGiaiQuyetLan2" require bindValidator={this} label='Kết quả giải quyết' selectedValue={this.state.ketQuaGiaiQuyetLan2} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetLan2')}/>
                </ShowIf>
                <ShowIf condition={this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && (Number(this.state.soLanGiaiQuyetLai) > 1)}>
                  <TextArea className='col-100' label='Lý do' require bindValidator={this} channel='formTaoDon' value={this.state.noiDungKetLuanGiaiQuyetLai} onChange={this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai')} name="noiDungKetLuanGiaiQuyetLai" maxLength={1000}/>
                </ShowIf>
              </div>
            }
            {
              DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' &&
              <div className="row pl10 pr10">
                <InputNumber className="col-25 mb0-18" label="Số vụ" name="soVu" value={this.state.soVuGiaiQuyetKhieuNai} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')}/>
                <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.props.loaiDon} label={ketLuanNDKhieuNaiLabel} className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
              </div>
            }
            {
              DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' &&
              <div className="row pl10 pr10">
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                  <Input className="col-50 mb0-18" type="sdt" name="tienPhaiThuNhaNuocQDGQ" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')}/>
                  <Input className="col-50 mb0-18" type="sdt" align="right" name="datPhaiThuNhaNuocQDGQ" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')}/>
                </div>
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                  <Input className="col-50 mb0-18" type="sdt" align="right" name="tienPhaiTraCongDanQDGQ" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')}/>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" name="datPhaiTraCongDanQDGQ" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')}/>
                </div>
                <div className="col-100 no-gutter">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                  <InputNumber className="col-25" name="tongSoNguoiXuLyHanhChinh" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')}/>
                  <InputNumber className="col-25" name="soNguoiDaBiXuLyHanhChinh" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')}/>
                  <InputNumber className="col-25" name="soNguoiDuocTraLaiQuyenLoi" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')}/>
                </div>
              </div>
              /*End block edit thong tin quyet dinh giai quyet*/
            }
            <div className="wrap-big-line pt5 pb15">
              <span className="big-border"></span>
            </div>
            <div className="col-100 no-gutter mt5">
              <h2 className="title-14 mb15">Theo dõi thực hiện</h2>
            </div>
            <div className="col-100 no-gutter pt5 pb15">
              <span className="line-border"></span>
            </div>
            <ShowIf condition={DataDetail.giaoCoQuanDieuTra}>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                  <div className="row pl10 pr10">
                    <Text className="col-25 mb0-18" label="Tên cơ quan:" value={DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : ''}/>
                    <Text className="col-25 mb0-18" label="Số vụ:" value={String(DataDetail.soVuGiaoCoQuanDieuTra)}/>
                    <Text className="col-25 mb0-18" label="Số đối tượng:" value={String(DataDetail.soDoiTuongGiaoCoQuanDieuTra)}/>
                  </div>
                </div>
                <div className="col-100 no-gutter pt5 pb15">
                  <span className="line-border"></span>
                </div>
              </div>

              <div className="col-100 no-gutter">
                <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                  <div className="col-100 no-gutter mt5 pb20">
                    <h2 className="title-12 mb15">Khởi tố</h2>
                    <div className="row pl10 pr10">
                      <div className="col-50 no-gutter">
                        <InputNumber className="col-50 mb0-18" name="soVuBiKhoiTo" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                        <InputNumber className="col-50 mb0-18" name="soDoiTuongBiKhoiTo" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255} />
                      </div>
                    </div>
                  </div>
                </ShowIfCheck>
                <div className="col-100 no-gutter pt5 pb15">
                  <span className="line-border"></span>
                </div>
              </div>
            </ShowIf>

            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter mt5 pb20">
                <h2 className="title-12 mb15">Nội dung Theo dõi thực hiện</h2>
                <div className="row pl10 pr10 mb20">
                  <ShowIf condition={this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI'}>
                    <DropDownMulipleUse className="col-25 mb0-18" label="Cơ quan theo dõi" bindValidator={this} selectedValue={this.state.coQuanTheoDoi} onChange={this.onChange.bind(this, 'coQuanTheoDoi')} name='coQuanTheoDoi' data={this.state.dataCoQuanTheoDoi} keyName='giaTri' valueName='ten'/>
                  </ShowIf>
                </div>
                <div className="row pl10 pr10 mb20">
                  <DropDownChonKetQuaThucHien className="col-25 mb0-18" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.ketQuaThucHienTheoDoi} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoi')}/>
                  <Input className="col-25 mb0-18" label="Kết quả thực hiện khác" value={this.state.ketQuaThucHienKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienKhac')} name='ketQuaThucHienKhac'/>
                </div>
                <div className="row pl10 pr10">
                  <div className="col-100 no-gutter mb20">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuoc')} name="tienPhaiThuTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuoc')} name="datPhaiThuTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ)" value={this.state.tienDaThuNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuNhaNuoc')} name="tienDaThuTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2)" value={this.state.datDaThuNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuNhaNuoc')} name="datDaThuTheoDoiThucHien"/>
                  </div>
                  <div className="col-100 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDan} onChange={this.onChange.bind(this, 'tienPhaiTraCongDan')} name="tienPhaiTraTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDan} onChange={this.onChange.bind(this, 'datPhaiTraCongDan')} name="datPhaiTraTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ)" value={this.state.tienDaTraCongDan} onChange={this.onChange.bind(this, 'tienDaTraCongDan')} name="tienDaTraTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2)" value={this.state.datDaTraCongDan} onChange={this.onChange.bind(this, 'datDaTraCongDan')} name="datDaTraTheoDoiThucHien"/>
                  </div>
                </div>
              </div>
            </div>
          </ShowIf>
          <ShowIf condition={DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
            <div className="col-100 no-gutter pt5 pb15">
              <span className="line-border"></span>
            </div>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định đình chỉ</h3>
            <Text className="col-25 pl0 mb10" label="Số văn bản:" value={DataDetail.soVanBan || ''}/>
            <Text className="col-25 mb10" label="Ngày ban hành:" value={DataDetail.ngayBanHanh ? moment(DataDetail.ngayBanHanh).format('DD/MM/YYYY') : ''}/>
            <Text className="col-25 mb10" label="Người ký:" value={DataDetail.nguoiBanHanhInfo ? DataDetail.nguoiBanHanhInfo.hoVaTen : ''}/>
            <TextMessage className='col-100 pl0 mb15' label='Lý do đình chỉ:' value={DataDetail.lyDoBanHanhQuyetDinhDinhChi || ''}/>
          </ShowIf>

          <ShowIf condition={this.state.showFile}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem
                name="GiaoCQDT"
                label="Danh sách văn bản xử lý"
                bindValidator={this}
                dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView}
                data={this.state.listTaiLieuVanThuGiaiQuyetDon}
                onSave={this.state.onSave}
                onFileRemove={this.onFileRemove.bind(this)}
                onFileChange={this.onFileChange.bind(this)}
              />
            </div>
          </ShowIf>
          <ShowIf condition={!DataDetail.boSungThongTin && (DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(DataDetail.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} dataShow={DataDetail.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
          <ShowIf condition={DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin}>
            <div className="box-bottom gqd-wrap col-100">
              <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'luuHoSo')}><span>Lưu hồ sơ</span></Link>
              <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

CanBoNhanYeuCauTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon,
  }
}

export default connect(bindStateToProps)(CanBoNhanYeuCauTheoDoiThucHien);


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/CanBoNhanYeuCauTheoDoiThucHien.jsx